









































import {Component, PropSync, Watch} from 'vue-property-decorator'
import {Action} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {notifyError, notifyWarning} from "@/utils/notify-helper";
import { SoundFilter } from '@/store/call/sounds/types';
import {getTranslatedParams} from "@/utils/notify-utils";
import {SelectWings} from "wings-ui-components";

@Component({components: {SelectWings}})
export default class CallSoundsFilter extends BaseFilter<SoundFilter> {
  @PropSync('filterProp') filterParent!: SoundFilter;
  @PropSync('runFilter') run!: boolean;
  @PropSync('show') is_show!: boolean;
  @Action('actionLog') actionLog: any;
  @Action('getSounds') actionGetSounds: any;
  @Action('getPartners') actionGetPartners: any;

  partnersList: any = [];

  defaultFilter(): SoundFilter {
    return { name: undefined, partner_id: undefined, page_number: 1 };
  }

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners(filter);
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items;
  }

  getPartnerName(partnerId: number | undefined): string {
    if (!partnerId) return '';
    const partner = this.partnersList.find((p: any) => p.id === partnerId);
    return partner ? partner.name : '';
  }

  async created() {
    await this.getDefaultPageSize();
    if (this.filter.partner_id) {
      this.partnersList = await this.actionGetPartners({id: this.filter.partner_id});
    }
    try {
      await this.actionGetSounds(this.filter);
    } catch (err) {
      notifyError(err);
    }
    this.scroll();
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: 'Viewing',
        action_status: 'success',
        object_type: 'Sound library',
        addititional_info: getTranslatedParams(this.filter)
      };
      const resp = await this.actionGetSounds(this.filter);
      await this.actionLog(this.logObject);

      const items = resp?.data?.sounds ?? [];
      if (!items.length) {
        this.is_last = true;
        if (!nextPage) {
          notifyWarning();
        }
      } else {
        this.is_last = false;
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: 'failed'});
      notifyError(err);
    } finally {
      this.moreLoading = false;
    }
  }

  @Watch('filter', { immediate: true, deep: true })
  onFilterChanged(val: SoundFilter) {
    this.filterParent = val;
  }

  @Watch('run')
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.run = false;
  }
}
